import { useRef } from 'react';

/**
 * Descarta o resultado de requisições que já foram superadas por outra mais nova.
 *
 * O problema que isto resolve: o usuário filtra por A e, antes de A responder,
 * filtra por B. Se a resposta de A chegar depois da de B — o que acontece com
 * facilidade em rede lenta ou quando o primeiro filtro traz muito mais dados —
 * ela sobrescreve a tela, e o usuário vê o resultado de A com o filtro B
 * selecionado. Para quem está usando o sistema, parece "dado misturado" ou
 * "cache", e nenhuma limpeza de cache resolve.
 *
 * Uso, uma instância por tela (compartilhada por todas as funções de busca
 * daquela tela, para que uma supere a outra):
 *
 *     const requisicao = useRequisicaoMaisRecente();
 *
 *     const buscar = async () => {
 *         const id = requisicao.iniciar();
 *         const response = await api.get(url);
 *         if (!requisicao.ehAtual(id)) return; // superada: descarta
 *         setLista(response.data.records);
 *     };
 */
const useRequisicaoMaisRecente = () => {
    const sequenciaRef = useRef(0);

    return {
        /** Registra uma nova busca e devolve o identificador dela. */
        iniciar: () => {
            sequenciaRef.current += 1;
            return sequenciaRef.current;
        },
        /** true enquanto nenhuma busca mais nova tiver começado. */
        ehAtual: (id) => id === sequenciaRef.current,
    };
};

export default useRequisicaoMaisRecente;
